export default {
  contactUs: `Contact Us`,
  termsOfService: `Terms of Service`,
  termsOfUse: `Terms of Use`,
  privacyPolicy: `Privacy Policy`
};
